import clsx from 'clsx';
import {
  deleteSavedAddressFx,
  SavedAddress,
} from 'domains/savedAddresses';
import { FERadioButton } from 'ui-kit/components';
import { IMG_IC_24_DELETE } from 'images';
import { useUnit } from 'effector-react';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  formatAddressDetails,
  formatAddressPrimary,
} from './lib/formatAddress';
import style from './AddressRow.module.css';

type Props = {
  item: SavedAddress;
  selected: boolean;
  onSelect: () => void;
};

export const AddressRow = ({ item, selected, onSelect }: Props) => {
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteAddress = useUnit(deleteSavedAddressFx);

  const details = formatAddressDetails(item, {
    entrance: t('profile.addressEntrance'),
    floor: t('profile.addressFloor'),
    apartment: t('profile.addressApartment'),
    housing: t('profile.addressHousing'),
  });

  const handleDelete = (e: MouseEvent) => {
    e.stopPropagation();
    if (isDeleting) return;
    setIsDeleting(true);
    deleteAddress(item.id).finally(() => {
      setIsDeleting(false);
    });
  };

  return (
    <div
      className={style.row}
      onClick={onSelect}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <div className={style.radio}>
        <FERadioButton active={selected} />
      </div>
      <div className={style.text}>
        <p className={clsx('text-1', style.primary)}>
          {formatAddressPrimary(item)}
        </p>
        {!!details && (
          <p className={clsx('caption-1', style.secondary)}>{details}</p>
        )}
      </div>
      <button
        type='button'
        className={style.deleteButton}
        disabled={isDeleting}
        onClick={handleDelete}
        aria-label={t('profile.cardDelete')}
      >
        <img className={style.deleteIcon} src={IMG_IC_24_DELETE} alt='' />
      </button>
    </div>
  );
};
